<template>
  <div class="part2" v-if="attrs">
    <div class="tab flex">
      <div>{{ $t("参数") }}</div>
      <div class="flex flex-col">
        <span v-if="attrs.budsize">
          {{ $t('花苞大小') }}：{{ attrs.budsize }}
        </span>
        <span v-if="attrs.norm">
          {{ $t('规格') }}：{{ attrs.norm }}
        </span>
        <span v-if="attrs.maturity">
          {{ $t('成熟度') }}：{{ attrs.maturity }}
        </span>
        <span v-if="attrs.length">
          {{ $t('枝长') }}：{{ attrs.length }}
        </span>
        <span v-if="attrs.color">
          {{ $t('颜色') }}：{{ attrs.color }}
        </span>
        <span v-if="attrs.level">
          {{ $t('等级') }}：{{ attrs.level }}
        </span>
      
        <span>{{ $t("重量") }}：{{ info.weight }}kg</span>
      </div>
     
    </div>
    <div class="tab flex mt-5" v-if="info.supplier_info">
      <div>{{ $t("供货商") }}</div>
      <div class="flex flex-col">
        <span v-if="info.supplier_info.name">
          {{ $t('名称') }}：{{ info.supplier_info.name }}
        </span>
        <span v-if="info.supplier_info.address">
          {{ $t('地址') }}：{{ info.supplier_info.address }}
        </span>
      </div>
     
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { last } from "ramda";
export default {
  props: { info: Object },
  setup(props, ctx) {
    const attrs = props.info?.complete_attrs

    return { attrs };
  },
};
</script>

<style scoped lang="scss">.tab {
  display: -ms-grid;
  display: grid;
  grid-gap: 1.5rem;
  gap: 1.5rem;
  grid-template-columns: auto 1fr;
}
.tab >div {
  text-align: left;
}
.tab >div > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}</style>
